import { PERMITTED_VIEWS } from './global.constant';

export const USER_VALIDATIONS = {
  USER_NAME: { MAX_LENGTH: 20 },
  EMAIL: { MAX_LENGTH: 50 },
  BALANCE: { INT: 6, DEC: 2 },
  CREDIT: { INT: 6, DEC: 2 },
};

export const USER_AGENT = 'Agents';

export const TYPES_USER_PERMISSIONS = {
  ADMIN: 'admin',
  AGENT: 'agent',
  CASHDESK: 'cashdesk',
  COLLABORATOR_AGENT: 'collaboratorAgent',
  COLLABORATOR_OPERATOR: 'collaboratorOperator',
};

export const OPTION_STATUS = [
  {
    value: true,
    label: 'words.active',
  },
  {
    value: false,
    label: 'words.inactive',
  },
];

export const USER_EXCLUDED_TYPE = ['collaboratorAgent', 'agent'];

export const USER_SELECT_FROM_FILTER = 'filter';

export const OPTION_LOCKED_STATUS = [
  { label: 'words.yes', value: true },
  { label: 'words.no', value: false },
];

export const ROUTE_USER_MANAGEMENT = {
  USER: '/user-management/users',
  AGENT: '/user-management/agents',
  VERIFICATION_REQUESTS: '/players/verification-request',
};

export const MAX_ALLOWED_USER_CURRENCIES = 8;

export const VERIFICATION_STATUS = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  REJECTED: 'rejected',
};

export const VERIFICATION_MODAL = {
  MIN_ZOOM: 0.5,
  MAX_ZOOM: 3,
  ZOOM_STEP: 0.25,
  DEFAULT_ZOOM: 1,
  HISTORY_TAB: 2,
  TRANSLATE_PREFIX: 'players.verificationRequest',
};

export const OPTION_TYPE_ROLE_DATE = [
  {
    value: 'createdAt',
    label: 'tools.ipAddressRestriction.creationDate',
  },
  {
    value: 'updatedAt',
    label: 'tools.ipAddressRestriction.updateDate',
  },
];

export enum AgentDetailMainTab {
  INFO = 'info',
  TRANSACTIONS = 'transactions',
  BONUS = 'bonus',
  NETWORK = 'network',
  BLOCK_HISTORY = 'blockHistory',
  RESTRICTIONS = 'restrictions',
}

export const AGENT_MAIN_TAB_PERMISSIONS: Record<AgentDetailMainTab, string> = {
  [AgentDetailMainTab.INFO]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENTS,
  [AgentDetailMainTab.BLOCK_HISTORY]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_BLOCK_HISTORY_BTN,
  [AgentDetailMainTab.TRANSACTIONS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB,
  [AgentDetailMainTab.NETWORK]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_NETWORK_TAB,
  [AgentDetailMainTab.BONUS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_BONUS_TAB,
  [AgentDetailMainTab.RESTRICTIONS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENTS,
};

export const AGENT_NETWORK_CHILDREN = {
  AGENTS: 'agents',
  PLAYERS: 'players',
} as const;

export const AGENT_OWN_VIEWS = {
  ALL: 'all',
  ...AGENT_NETWORK_CHILDREN,
} as const;

export const AGENT_BONUS_TYPE_DATE = 'bonusCreationDate';

export const AGENT_TRANSACTIONS_MODES = {
  OWN: 'own',
  NETWORK: 'network',
  BONUS: 'bonus',
} as const;

export const AGENT_NETWORK_NODE_TYPE = {
  AGENT: 'agent',
  PLAYER: 'player',
} as const;

export const AGENT_NETWORK_PAGE_LIMIT = 10;
export const AGENT_NETWORK_MAX_PLAYER_IDS = 100;

export const AGENT_OWN_EXTRA_FILTER_KEYS = [
  'transactionId',
  'type',
  'operationType',
  'stateTransaction',
  'registeredBy',
] as const;

export const AGENT_NETWORK_LOAD_STEPS = [10, 25, 50];

export const AGENT_NETWORK_SUBLEVEL_LOAD_STEPS = [10, 25];

export const AGENT_BONUS_COLUMN_ORDER = [
  'reports.bonus.playerBonusId',
  'reports.casino.playerId',
  'financial.holders.player',
  'reports.bonus.bonusId',
  'reports.bonus.typeBonus',
  'reports.bonus.bonusName',
  'reports.bonus.code',
  'reports.bonus.bonusAmount',
  'words.amountDeposited',
  'reports.bonus.amountBonusPaid',
  'reports.bonus.amountBonusGenerated',
  'reports.bonus.bonusStatus',
  'reports.bonus.stateResult',
  'reports.bonus.createdAt',
  'reports.bonus.acceptanceDate',
  'reports.bonus.expirationDate',
  'reports.bonus.claimDate',
  'reports.bonus.updateBonusRegisterDate',
  'reports.bonus.dateOfResult',
  'reports.bonus.wasDeposit',
  'reports.bonus.product',
  'reports.bonus.reasonCancellation',
];

export const AGENT_BONUS_HIDDEN_COLUMNS = [
  'reports.bonus.agentExternalId',
  'reports.bonus.agency',
  'reports.transactions.currencyId',
  'reports.bonus.playerCategory',
];

export const AGENT_NETWORK_FIRST_LOAD_SKELETON_ROWS = 3;

export const AGENT_NETWORK_MAX_LEVEL = 9;

export const AGENT_OWN_TRANSACTIONS_COLUMN_ORDER = [
  'words.date',
  'reports.transactions.idTransaction',
  'reports.transactions.type',
  'reports.transactions.operationType',
  'reports.transactions.amount',
  'reports.transactions.previousBalanceShort',
  'reports.transactions.currentBalanceShort',
  'reports.transactions.realisatedBy',
];

export const AGENT_ALL_TRANSACTIONS_COLUMN_ORDER = [
  'reports.transactions.idTransaction',
  'reports.transactions.usernamePlayer',
  'words.date',
  'reports.transactions.type',
  'reports.transactions.operationType',
  'reports.transactions.origin',
  'reports.transactions.amount',
  'reports.transactions.previousBalanceShort',
  'reports.transactions.currentBalanceShort',
  'reports.transactions.realisatedBy',
  'words.status',
];

export const AGENT_ALL_TRANSACTIONS_HIDDEN_COLUMNS = [
  'reports.transactions.IP',
  'reports.transactions.comment',
  'reports.transactions.performedByUserId',
  'financial.transactions.filter.userId',
  'players.blocked.accordion.playerId',
  'reports.transactions.previousRegisteredCredit',
  'reports.transactions.currentRegisteredCredit',
  'reports.transactions.currencyId',
  'reports.transactions.previousCredit',
  'reports.transactions.currentCredit',
  'reports.transactions.previousRegisteredBalance',
  'reports.transactions.currentRegisteredBalance',
  'reports.transactions.belongsTo',
  'userManagement.users.role',
];

export const AGENT_OWN_TRANSACTIONS_HIDDEN_COLUMNS = [
  'reports.transactions.comment',
  'reports.transactions.IP',
  'reports.transactions.currencyId',
];

export const AGENT_PLAYERS_TRANSACTIONS_COLUMN_ORDER = [
  'reports.transactions.idTransaction',
  'reports.transactions.usernamePlayer',
  'words.date',
  'reports.transactions.type',
  'reports.transactions.operationType',
  'reports.transactions.amount',
  'reports.transactions.previousBalanceShort',
  'reports.transactions.currentBalanceShort',
  'reports.transactions.realisatedBy',
  'words.status',
  'players.blocked.accordion.agentUserName',
  'reports.transactions.currencyId',
  'reports.transactions.comment',
];

export const AGENT_PLAYERS_TRANSACTIONS_HIDDEN_COLUMNS = ['reports.transactions.IP'];

export const AGENT_OWN_VIEW_PERMISSIONS = {
  [AGENT_OWN_VIEWS.ALL]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_ALL,
  [AGENT_NETWORK_CHILDREN.AGENTS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_AGENTS,
  [AGENT_NETWORK_CHILDREN.PLAYERS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_PLAYERS,
};

export const AGENT_TRANSACTIONS_VIEW_LABELS = {
  [AGENT_TRANSACTIONS_MODES.OWN]: {
    [AGENT_OWN_VIEWS.ALL]: 'agents.agent.transactions.ownAllView',
    [AGENT_NETWORK_CHILDREN.AGENTS]: 'agents.agent.transactions.ownAgentsView',
    [AGENT_NETWORK_CHILDREN.PLAYERS]: 'agents.agent.transactions.ownPlayersView',
  },
  [AGENT_TRANSACTIONS_MODES.NETWORK]: {
    [AGENT_NETWORK_CHILDREN.AGENTS]: 'agents.agent.transactions.agentsView',
    [AGENT_NETWORK_CHILDREN.PLAYERS]: 'agents.agent.transactions.playersView',
  },
};

export const AGENT_NETWORK_VIEW_PERMISSIONS = {
  [AGENT_NETWORK_CHILDREN.AGENTS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_AGENTS,
  [AGENT_NETWORK_CHILDREN.PLAYERS]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_TRANSACTIONS_PLAYERS,
};

export enum AgentDetailTab {
  PERSONAL = 'personal',
  CONTACT = 'contact',
  AGENCY = 'agency',
  COMMISSIONS = 'commissions',
  REFERRED = 'referred',
  SECURITY = 'security',
}

export const AGENT_SECTION_PERMISSIONS: Partial<Record<AgentDetailTab, string>> = {
  [AgentDetailTab.SECURITY]: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_UPDATE_PASSWORD_BTN,
};

export const AGENT_FORM_SECTION_CONTROLS: Record<AgentDetailTab, string[]> = {
  [AgentDetailTab.PERSONAL]: [
    'firstName',
    'lastName',
    'documentNumber',
    'birthCountryId',
    'birthCityId',
    'birthDate',
    'address',
    'gender',
  ],
  [AgentDetailTab.CONTACT]: [
    'email',
    'conventionalNumber',
    'telephoneCodeId',
    'mobileNumber',
    'whatsappCodeId',
    'whatsappNumber',
  ],
  [AgentDetailTab.AGENCY]: [
    'username',
    'countryId',
    'cityId',
    'currencyId',
    'roleId',
    'languageId',
    'localName',
    'localPhone',
    'localWhatsappCodeId',
    'localWhatsappNumber',
    'localAddress',
    'localMapLink',
    'localOpeningTime',
    'localClosingTime',
  ],
  [AgentDetailTab.COMMISSIONS]: ['comissionPlanId', 'transactionCommission'],
  [AgentDetailTab.REFERRED]: ['referred'],
  [AgentDetailTab.SECURITY]: [],
};

export const AGENT_ACTIONS_COLUMN_WIDTH = 80;
